export const availableReports = [
    {
        id: "regimeCountByClient",
        title: "Maintenance Regimes Created",
        component: "Report",
        columns: [
            { title: "Company", value: "clientName", size: 6, alignment: "left" },
            { title: "Regimes", value: "count", size: 3, alignment: "right" },
        ],
    },

    {
        id: "sfg20ScheduleUsageCount",
        title: "SFG20 Schedules Used in Maintenance Regimes",
        component: "Report",
        columns: [
            { title: "Code", value: "code", size: 3, alignment: "left" },
            { title: "Title", value: "title", size: 6, alignment: "left" },
            { title: "Times Used", value: "count", size: 3, alignment: "right" },
        ],
    },
    {
        id: "scheduleUsageCountByClient",
        title: "Schedules Used in Maintenance Regimes, by Company",
        component: "ReportByClient",
        columns: [
            { title: "Code", value: "code", size: 3, alignment: "left" },
            { title: "Title", value: "title", size: 6, alignment: "left" },
            { title: "Uses", value: "count", size: 3, alignment: "right" },
        ],
    },
    {
        id: "licenceUsageCount",
        title: "Licence Utilisation",
        component: "Report",
        columns: [
            { title: "Client", value: "client", size: 4, alignment: "left" },
            { title: "View", value: "view", size: 1, alignment: "right" },
            { title: "(Max)", value: "totalView", size: 1, alignment: "right" },
            { title: "Collaborate", value: "collaborate", size: 1, alignment: "right" },
            { title: "(Max)", value: "totalCollaborate", size: 1, alignment: "right" },
            { title: "Client", value: "create", size: 1, alignment: "right" },
            { title: "(Max)", value: "totalCreate", size: 1, alignment: "right" },
            { title: "Regime", value: "regimes", size: 1, alignment: "right" },
            { title: "(Max)", value: "totalRegimes", size: 1, alignment: "right" },
        ],
    },
    {
        id: "customSchedulesByClient",
        title: "Custom Schedules Created, by Company",
        component: "Report",
        columns: [
            { title: "Company", value: "clientName", size: 6, alignment: "left" },
            { title: "Schedules", value: "count", size: 3, alignment: "right" },
        ],
    },
    {
        id: "tailoredScheduleCount",
        title: "Schedule Tailoring Count",
        component: "Report",
        columns: [
            { title: "Code", value: "code", size: 3, alignment: "left" },
            { title: "Title", value: "title", size: 6, alignment: "left" },
            { title: "Count", value: "count", size: 3, alignment: "right" },
        ],
    },
    {
        id: "tailoredScheduleUsageCountByClient",
        title: "Tailored Schedule Usage, by Company",
        component: "ReportByClient",
        columns: [
            { title: "Code", value: "code", size: 3, alignment: "left" },
            { title: "Title", value: "title", size: 6, alignment: "left" },
            { title: "Count", value: "count", size: 3, alignment: "right" },
        ],
    },

    {
        id: "apiTokensByAuthorisedDomain",
        title: "API Tokens by Authorised Domain",
        component: "Report",
        columns: [
            { title: "Domain", value: "domain", size: 6, alignment: "left" },
            { title: "API Tokens", value: "count", size: 3, alignment: "right" },
        ],
    },

    {
        id: "apiTokensByOrganisation",
        title: "API Tokens by Organisation",
        component: "Report",
        columns: [
            { title: "Organisation", value: "organisation", size: 6, alignment: "left" },
            { title: "API Tokens", value: "count", size: 3, alignment: "right" },
        ],
    },

    {
        id: "unlicensedContent",
        title: "Unlicensed Content",
        component: "Report",
        columns: [
            { title: "Client", value: "client", size: 2, alignment: "left" },
            { title: "User", value: "user", size: 2, alignment: "left" },
            { title: "Content", value: "content", size: 6, alignment: "right" },
            { title: "Date", value: "date", size: 2, alignment: "right" },
        ],
    },
    {
        id: "tieredAccessAttemptsByClient",
        title: "Tiered Access Attempts, by company",
        component: "ReportByClient",
        columns: [
            { title: "Access Type", value: "tab", size: 4, alignment: "left" },
            { title: "Count", value: "count", size: 2, alignment: "left" },
            { title: "Total", value: "total", size: 2, alignment: "right" },
        ],
    },
]
